export const FAILED_OUTGOING_STATES = [
  { id: 'Falha no último envio', i18nKey: 'UNANSWERED' },
  { id: 'Sucesso no último envio', i18nKey: 'ANSWERED' },
  { id: 'Todos', i18nKey: 'ALL' },
];

export const FAILED_OUTGOING_UNANSWERED = FAILED_OUTGOING_STATES[0].id;

export default FAILED_OUTGOING_STATES;
